import { QueryStringParamName } from 'app/shared/models/common.enums';

export class LocationWrapper {
  public search(): string {
    return location.search;
  }
  public getParamValue(paramName: QueryStringParamName): string {
    const locationParams = this.search();
    const params = new URLSearchParams(locationParams);
    let paramValue: string = null;
    params.forEach((value, key) => {
      if (key.toLocaleLowerCase() === paramName.toLocaleLowerCase()) {
        paramValue = value;
      }
    });
    return paramValue;
  }
}
